<template>
  <v-layout wrap style="">
    <v-flex xs8 style="padding: 10px;">
      <div style="background-color: white;">
    <v-data-table
      :headers="headers.filter(x => x.value !== 'WorkspaceName' || devices.filter(x => !x.WorkspaceID).length > 0)"
      :items="devices"
      :items-per-page="-1"
      class="elevation-0"
      hide-default-footer
    >      
      <template 
        v-slot:top 
      >
        <v-layout wrap>
          <v-flex
            xs="6"
            style="padding-left:10px;"
          >
            <h1><v-icon large color="black">mdi-android</v-icon> {{$t('players.players', locale)}}</h1>
          </v-flex>
          <v-flex
            xs="6"
            style="padding:10px;"
          >
            <v-layout wrap>
              <v-flex xs6 style="padding-left:10px;">
                <search :onSearch="handleSearch" :showClear="searchValue && searchValue.length > 0 ? true : false" :maxWidth="400" />
              </v-flex>
              <v-flex xs6 style="text-align: right;">
                <v-btn 
                  @click="handleGetData(null)"
                  block
                >
                  {{ $t('common.refresh', locale) }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:item.Presentation="{ item }" style="background-color: orange;">
        <template-presentation
          :item="item"
          :onClick="handleEditPresentationByID"
        />
      </template>
      <template v-slot:item.ident="{ item }">
        <a @click="editedID = item.ID" :style="{ color: !item.Active ? 'orange' : null }">{{item.Name ? item.Name : prepareCode(item) }}</a>
      </template>
      <template v-slot:item.LCD="{item}">
        <span
          :style="{ color: item.Seconds > item.Time ? 'red' : 'green' }"
        >
          {{getDate(item.LCD)}}
        </span>
      </template>
    </v-data-table>
    <pagination
      v-if="count!= null"
      :startIndex="startIndex"
      :count="count"
      :itemsPerPage="itemsPerPage"
      :onGetData="handleGetData"
      :locale="locale"
      :onChangeItemsPerPage="handleChangeItemsPerPage"
      :arrayPages="[5, 10, 15, 20, 25, 30, 50]"
    />
      </div>
    <!--player-form /-->
    </v-flex>
    <v-flex xs4 style="padding: 10px;">
      <!--v-btn 
        v-if="!editedID"
        @click="handleAddItem"
        block
        color="primary"
      >
        añadir
      </v-btn-->
      <div
        style="padding: 10px;background-color:white;min-height: calc(100vh);"
      >
        <android-form
          v-if="editedID && workspaceID"
          :workspaceID="workspaceID"
          :editedID="editedID"
          :onClose="handleClose"
          :presentations="presentations"
        />
        <presentation-form
          v-else-if="editedPresentationID && workspaceID"
          :workspaceID="workspaceID"
          :editedID="editedPresentationID"
          :onClose="handleClosePresentationForm"
          :templates="templates"
          :presentations="presentations"
          :locale="locale"
          :fromPlayerList="true"
        />
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import sec from '@/services/sec'
import Search from '@/components/Search'
import Pagination from '@/components/customTable/Pagination'
import TemplatePresentation from './TemplatePresentation'
import AndroidForm from './AndroidForm'
import PresentationForm from '../presentations/PresentationForm'
export default {
  components: {
    Search,
    Pagination,
    TemplatePresentation,
    AndroidForm,
    PresentationForm,
  },
  data: () => ({
    count: null,
    startIndex: 0,
    itemsPerPage: 15,
    presentations: [],
    devices: [],
    editedID: null,
    editedPresentationID: null,
    searchValue: '',
    templates: [],
    allowEditPresentation: false,
  }),
  computed: {
    ...mapState('app',['locale', 'playersWorkspace']),
    workspaceID () {
      return this.playersWorkspace
    },  
    environment () {
      return 'players'
    },
    headers () {
      return [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'ident',
        },
        { text: 'Cliente', sortable: false, value: 'WorkspaceName' },
        { text: 'Presentation', align: 'center', sortable: false, value: 'Presentation' },
        { text: 'Time(seg)', sortable: false, value: 'Time' },
        { text: 'APK', align: 'center', sortable: false, value: 'APK' },
        { text: 'LCD', sortable: false, value: 'LCD' },
        { text: 'LCD', sortable: false, value: 'Seconds' },
      ]
    },
  },
  watch: {
    playersWorkspace () {
      this.handleGetPresentations()
    },
  },
  mounted () {
    this.handleGetTemplates()
    const aux = localStorage.getItem('playerItemsPerPage')
    if (aux && aux !== this.itemsPerPage) this.itemsPerPage = aux && aux.length > 0 ? aux | 0 : 15
    //this.handleGetData()
    this.handleGetPresentations()
  },
  methods: {
    prepareCode (v) {
      if (!v.TerminalID) return v.ID
      const aux = v.TerminalID.split('-')
      return aux[1]
    },
    handleGetTemplates () {
      const url = 'v1/private/templates'
      api.getAllWithoutLimit (this.environment, url)
        .then(response => {
          this.templates = response
        })
    },
    getDate (v) {
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }

      return v.toLocaleDateString('es', options)
    },
    handleGetPresentations () {
      this.presentations = []
      this.count = 0
      this.devices = []
      if (!this.workspaceID) return
      
      //const url = 'v1/private/presentations/'
      const url = `v1/private/workspaces/${this.workspaceID}/presentations/`
      api.getAllWithoutLimit (this.environment, url)
        .then(response => {
          this.presentations = response.data
          this.handleGetData()
        })
    },
    handleChangeItemsPerPage (v) {
      this.startIndex = 0
      this.itemsPerPage = v
      localStorage.setItem('playerItemsPerPage', v)
      this.handleGetData()
    },
    handleSearch (v) {
      this.searchValue = v
      this.handleGetData()
    },
    async handleGetData (v) {
      this.allowEditPresentation = await sec.checkPermission('players', this.workspaceID, '7fe5786c-4383-42f2-a6f9-27cde9305e60')
      this.handleClose()
      this.count = 0
      this.devices = []
      if (!this.workspaceID) return
      if (v !== null && v != undefined) this.startIndex = v

      //const url = 'v1/private/android/'
      const url = `v1/private/workspaces/${this.workspaceID}/android/`
      api.getAll (this.environment, url, this.startIndex, this.itemsPerPage, this.searchValue)
        .then(response => {
          this.count = response.count
          this.devices = response.data.map(item => {
            item.ident = {
              ID: item.ID,
              Name: item.Name,
            }
            item.Presentation = this.presentations.filter(x => x.ID ===item.PresentationID).map(item=>item.Name).shift()
            item.LCD = item.LCD ? new Date(item.LCD) : null
            return item
          })
        })
    },
    handleAddItem () {
      this.editedID = 'new'
    },
    handleClose (refresh) {
      this.editedID = null
      this.editedPresentationID = null
      if (refresh) this.handleGetData()
    },
    handleClosePresentationForm (refresh) {
      this.editedID = null
      this.editedPresentationID = null
      if (refresh) this.handleGetPresentations()
    },
    handleGoToActivate () {
        this.$router.push('/players/activate')
    },
    handleEditPresentationByID (v) {
      if (!this.allowEditPresentation) return
      this.editedPresentationID = v
    },
  },
}
</script>

